import PropTypes from "prop-types"
import React, {useEffect, useRef, useState} from "react"

import {DetailInfoRow, LoadingIndicator} from "~/components/"
import ShelfApi from "~/utils/ShelfApi"
import {DragDropFile} from "./DragDropFile"

export const UploadForm = ({type, label, allowedFileTypes, onUpload}) => {
  const [file, setFile] = useState()
  const inputRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [statusText, setStatusText] = useState("")

  useEffect(() => {
    if (file) {
      uploadDocument()
    }
  }, [file])

  const handleFileChange = e => {
    if (!e.target.filesd) {
      return
    }
    setFile(e.target.files[0])
  }

  const uploadDocument = file => {
    if (onUpload) {
      onUpload(true)
    }

    if (loading) return
    setLoading(true)

    setStatusText("")
    const formData = new FormData()
    formData.append(`${type}_upload[file]`, file)
    formData.append(`${type}_upload[title]`, file.name)

    ShelfApi.post(`/${type}_uploads/`, formData, {
      headers: {
        "content-type": "multipart/form-data"
      }
    })
      .then(() => {
        setStatusText("wurde erfolgreich hochgeladen")
      })
      .catch(res => {
        setStatusText("konnte nicht hochgeladen werden")
      })
      .finally(() => {
        if (onUpload) {
          onUpload(false)
        }

        setLoading(false)
      })
  }

  return (
    <DetailInfoRow>
      <div style={styles.inner}>
        <label>
          <span>{label}</span>
          <DragDropFile
            handleFiles={uploadDocument}
            loading={loading && <LoadingIndicator message={""} />}
            allowedFileTypes={allowedFileTypes}
            renderStatusText={statusText}
          ></DragDropFile>
        </label>
      </div>
    </DetailInfoRow>
  )
}

UploadForm.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string
}

const styles = {
  inner: {
    padding: "6px 12px"
  },
  fileInput: {
    backgroundColor: "#FFF"
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 12
  },
  statusText: {
    fontSize: "1.3em",
    paddingTop: "8px"
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/UploadForm.js